export default function (contentType: string): string {
  if (contentType.startsWith('image/')) return 'image';
  if (contentType.startsWith('video/')) return 'video_file';
  if (contentType.startsWith('audio/')) return 'audio_file';
  if (contentType === 'application/pdf') return 'picture_as_pdf';
  if (contentType.includes('zip') || contentType.includes('archive')) return 'folder_zip';
  if (contentType.startsWith('text/')) return 'article';
  return 'description';
}
